import graphqlClient from '../graphql';
import {
  cancelShipmentItemsForReviewGql,
  cancelShipmentItemsFromOrderGql,
  createManualShipmentGql,
  getShipmentAuditEventsGql,
  splitShipmentItemsGql,
  updateShipmentItemsGql,
} from './gql';

export const createManualShipmentApi = (input) =>
  graphqlClient
    .request(createManualShipmentGql, { input })
    .then(({ createShipment }) => createShipment);

export const getShipmentAuditEventsApi = ({ shipmentId, referenceId }) =>
  graphqlClient
    .request(getShipmentAuditEventsGql, { shipmentId, referenceId })
    .then(({ getShipmentAuditEvents }) => getShipmentAuditEvents);

export const updateShipmentItemsApi = ({ transfers, signal }) =>
  graphqlClient
    .request({ document: updateShipmentItemsGql, variables: { transfers }, signal })
    .then(({ updateShipmentItems }) => updateShipmentItems);

export const splitShipmentItemsApi = ({ shipmentId, referenceId, itemReferenceIds, signal }) =>
  graphqlClient
    .request({
      document: splitShipmentItemsGql,
      variables: { input: { shipmentId, referenceId, itemReferenceIds } },
      signal,
    })
    .then(({ splitShipmentItems }) => splitShipmentItems);

export const cancelShipmentItemsForReviewApi = ({
  shipmentId,
  referenceId,
  itemReferenceIds,
  signal,
}) =>
  graphqlClient
    .request({
      document: cancelShipmentItemsForReviewGql,
      variables: { input: { shipmentId, referenceId, itemReferenceIds } },
      signal,
    })
    .then(({ cancelShipmentItemsForReview }) => cancelShipmentItemsForReview);

export const cancelShipmentItemsFromOrderApi = ({
  shipmentId,
  referenceId,
  itemReferenceIds,
  signal,
}) =>
  graphqlClient
    .request({
      document: cancelShipmentItemsFromOrderGql,
      variables: { input: { shipmentId, referenceId, itemReferenceIds } },
      signal,
    })
    .then(({ cancelShipmentItemsFromOrder }) => cancelShipmentItemsFromOrder);
